<template>
  <v-layout wrap pa-3>
      <v-flex sm12 pr-2>
        <v-text-field clearable v-model="adminFilterSearch" :label="$t('Admin.Search')" append-icon="mdi-magnify" />                
      </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {FilterBase} from '@/models/filter/FilterBase'

@Component({
  name: 'AdminFilter',   
   props: {       
     itemTypeName:String
  }
})
export default class AdminFilter extends Vue {  
  itemTypeName!:string

  get adminFilterSearch() {    
    //@ts-ignore
    return this.$store.myGetters[`admin${this.itemTypeName}Filter`].search
  }
  set adminFilterSearch(value) {
    //@ts-ignore
    this.$store.myActions[`${this.itemTypeName.toUpperCase()}_UPDATE_FILTER_ADM`]({search:value == null?"":value})
  } 
}
</script>